import { render, staticRenderFns } from "./RequestCreditForm.vue?vue&type=template&id=628464f9&scoped=true"
import script from "./RequestCreditForm.vue?vue&type=script&lang=js"
export * from "./RequestCreditForm.vue?vue&type=script&lang=js"
import style0 from "./RequestCreditForm.vue?vue&type=style&index=0&id=628464f9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628464f9",
  null
  
)

export default component.exports